import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => import(`./pages/pages.module`).then(m => m.PagesModule)
    },
    {
        path: '',
        loadChildren: () => import(`./features/features.module`).then(m => m.FeaturesModule),
    },
    {
        path: '**',
        redirectTo: 'page-not-found',
        pathMatch: 'full'
    },

];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        onSameUrlNavigation: 'reload',
        paramsInheritanceStrategy: 'always'
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
